var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 68,
    viewBox: "0 0 62 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4697 8.76878C48.8777 10.1768 50.0617 11.9368 51.0217 14.0488H61.1017V22.0168H52.9417V23.2648C52.9417 28.1288 51.6617 32.3208 49.1017 35.8408C46.6057 39.3608 43.0217 41.9848 38.3497 43.7128L54.2857 68.0008H37.5817L23.2777 46.0168H4.36569V33.5368H22.2217C27.2777 33.5368 31.0217 32.4808 33.4537 30.3688C35.9497 28.2568 37.2297 25.4728 37.2937 22.0168H0.429688V14.0488H35.0857C32.5257 10.4648 28.0457 8.70478 21.6457 8.76878H0.429688V0.800781H61.1017V8.76878H47.4697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.262385f3ba2cf961b1469b68de8873f6.svg";
export { ForwardRef as ReactComponent };